import React from "react";

const GuideRolesFormGroup = (props) => {

    const roleExamples = [
        "a Friend",
        "a Brother",
        "a Mother",
        "a Sister",
        "an Uncle",
        "a Father"
    ]

    const getExample = (index) => {
        if (!roleExamples[index]) return getExample(index - 6)
        return roleExamples[index]
    }

    const handleSetRoles = (type, index) => {
        const newArr = [...props.realRoles]
        newArr[index].title = type
        props.setRealRoles(newArr.filter(t => t.title.length > 0)) // removes unused roles
    }
    
    const handleAddRole = (e) => {
        e.preventDefault()
        const newArr = [...props.realRoles]
        newArr.push({title:""})
        props.setRealRoles(newArr)
    }

    return (    
       <div className="form-group">
            <label>Real Roles</label>
            {props.realRoles.map((role,i) => <input type="text" key={`role-${i}`} value={role.title} placeholder={getExample(i)} onChange={(e) => handleSetRoles(e.target.value, i)} />)}
            <button className="manage-item-action add-input" onClick={handleAddRole}>+</button>
        </div>
    )
}

export default GuideRolesFormGroup;